<template>
  <div id="wrapper">
  <PageHeader />
  <div id="content">
  <HelloWorld :msg="questionSet.headingQuestion" />
  <QuizTerminal msg="Terminal" commandHead="quizteilnehmer@gonicus:~$&nbsp; "/>
  <div id="blankSpace"></div>
  </div>
  <div id="footer">
  <PageFooter/>
  </div>
  </div>
  <!--TestScriptSetup :msg="questionSet"></TestScriptSetup-->
  <!--QuizTerminal msg="Terminal" commandHead="quizteilnehmer@gonicus:~$&nbsp;" :questionSet="questionSet" /-->

</template>

<script>
import PageHeader from "../../components/PageHeader.vue";
import HelloWorld from "../../components/HelloWorld.vue";
import QuizTerminal from "../../components/QuizTerminal.vue";
import PageFooter from "../../components/PageFooter.vue";

export default {
  name: "App",
  components: {
    PageHeader,
    HelloWorld,
    QuizTerminal,
    PageFooter,
//    TestScriptSetup
  },
  data(){
    return{
    questionSet: String,
    };
  },
  mounted(){
    this.fetchData();
  },
  methods: {
   async fetchData() {
      let link = this.getCurrentURL();
      const response = await fetch(link);
      this.questionSet = await response.json();
   },
    getCurrentURL () {
      let link = window.location.href;
      let linkPart = link.split("#");
      let linkEnd = linkPart.slice(-1);
      let set = linkEnd[0]+".json";
      return set;
    }
  },
};
</script>

<style>
#wrapper{
  min-height: 100vh;
  display:flex;
  flex-direction: column;
}
#content{
  flex-grow: 1;
}
#footer{
  margin-top: auto;
}
body {
  padding: 0;
  margin: 0;
  
  background-color: #1e398f;
}
h1{
  color:white;
  font-size: 1.5em;
}

@media all and (min-width: 500px) {
  p {
    font-size: 1.5rem;
  }
  h1{
    font-size: 3rem;
  }
}

#app {
  font-family: Roboto, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-width: 75%;
}
</style>
